import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const APPLICANT_TASK_STATUSES: string[] = [
  'NEW_LEAD',
  'WORKING_LEAD',
  ChecklightSessionStatus.PENDING_SUBMISSION,
];
